var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAboutinline = function SvgAboutinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A0E0F",
    d: "M11.38 1.888h-1.266l.011 2.145h1.267l-.012-2.145Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00984A",
    d: "M6.066 1.872H4.8l.011 2.145h1.267l-.012-2.145ZM1.492 6.42l.557.859.61.781.664.707.698.606.753.505.786.404.804.277.803.177.84.05.819-.05.819-.177.801-.277.765-.404.747-.505.692-.606.674-.707.602-.781.531-.858 1.201 1.337-.583.934-.638.858-.673.757-.745.682-.764.579-.8.506-.836.377-.855.279-.873.15-.874.052-.892-.051-.856-.151-.858-.279-.84-.377-.823-.506-.77-.58-.735-.68-.7-.758-.647-.858-.575-.934L1.492 6.42Z"
  })));
};
export default SvgAboutinline;